import mixins from 'vue-typed-mixins';

import CourseProgressMixin from '@/user/mixins/CourseProgressMixin';
import RoomMixin from '@/user/mixins/RoomMixin';
import UserMixin from '@/user/mixins/UserMixin';

import ConfirmDialog from '@/user/components/dialog/confirm/ConfirmDialog.vue';
import { PublicRoutes } from '@/user/router/AppRouteConfig';



export default mixins(CourseProgressMixin, RoomMixin, UserMixin).extend({

  name: 'LogoutButton',

  components: {
    ConfirmDialog,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data(): {
    visibleLogoutDialog: boolean
  } {
    return {
      visibleLogoutDialog: false
    };
  },

  computed: {
    logoutConfirmText(): string {
      if (this.isManabi) return 'ウィンドウを閉じます。よろしいですか？';
      return 'ログアウトしてもよろしいですか？';
    },
  },

  methods: {
    logoutUser(): void {
      this.clearProgresses();
      this.logout();
      this.visibleLogoutDialog = false;
      // まなびポケットの場合はウインドウを閉じる
      if (this.isManabi) window.close();
      else               this.$router.push(PublicRoutes.LoginRedirect);
    },
  }



});
